import { render, staticRenderFns } from "./Phase2Container.vue?vue&type=template&id=6bae8294&scoped=true&"
import script from "./Phase2Container.vue?vue&type=script&lang=js&"
export * from "./Phase2Container.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bae8294",
  null
  
)

export default component.exports